import React from 'react';
import WebGenericFeedbackModal from '@boschebike/ebds-react/dist-esm/components/WebGenericFeedbackModal.js';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';

export const DodoFeedbackModal = ({
  dispatchHide,
  ...rest
}) => {
  return (
    <ModalSheet.Content>
      <WebGenericFeedbackModal
        {...rest}
        onDismiss={dispatchHide}
        onToast={(...args) => dodo.ui.dispatchToast(...args)}
        customImporter={() => {}}
      />
    </ModalSheet.Content>
  );
};
